// extracted by mini-css-extract-plugin
module.exports = {"container":"ScoreHistory_container__3R2-K","header":"ScoreHistory_header__D2PFx","title":"ScoreHistory_title__1VDBj","date":"ScoreHistory_date__2imxr"};